import { useGetUser } from '@vlabs/api/artemy/client';

interface CreatedByUserCellProps {
  userId: string;
}

function CreatedByUserCell({
  userId,
}: CreatedByUserCellProps): JSX.Element | null {
  const { data: user } = useGetUser(userId);
  if (!user) return null;
  return (
    <span>{user?.full_name ?? user?.login}</span>
  );
}

export { CreatedByUserCell };
